


































import { OrderRec } from '@/interfaces';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import DocumentMixin from '@/mixins/DocumentMixin';

@Component
export default class GroupDetail extends Mixins(DocumentMixin) {
  @Prop() public readonly rec!: OrderRec;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
}
